import { useState, useEffect } from "react";
import moment from "moment";
import { fetchData } from "../FetchData";
import { applyDefaultSelection } from "../utils/defaultSelections";
import logger from "../../../utils/logger";
import { barEmotionOrder } from "../../Dashboards/utils";
const initialState = {
  chosenSchool: "Choose School",
  chosenDistrict: "Choose District",
  chosenClass: "Choose Class",
  chosenStudent: "Choose Student",
  searchData: "",
  districts: {},
  chosenTime: "month",
  chosenTimeCompare: "month",
  allWellnessPoints: [],
  counter: 0,
  studentData: {},
  threeImpactfulActions: {},
  filterAmountCurrent: moment.duration(30, "days"),
  filterAmountCompare: moment.duration(30, "days"),
  feeling: "select",
  wellnessList: [],
  loading: true,
  counts: [
    { name: "sad", current: 0, compare: 0 },
    { name: "tired", current: 0, compare: 0 },
    { name: "lonely", current: 0, compare: 0 },
    { name: "happy", current: 0, compare: 0 },
    { name: "grateful", current: 0, compare: 0 },
    { name: "calm", current: 0, compare: 0 },
    { name: "stressed", current: 0, compare: 0 },
    { name: "scared", current: 0, compare: 0 },
    { name: "angry", current: 0, compare: 0 },
  ],
  allStudents: [],
  activeComponent: 0,
  studentEmailToNameMap: {},
  filteredDataPoints: [],
  lineGraphSourceData: [],
  lineGraphDerivedData: null,
  lineGraphSelectedEmotions: [...barEmotionOrder],
  chosenEmotion: "all emotions",
  chosenColor: "#C8FADD",
  studentEmotionData: {},
  chosenPercentage: "",
  bigFiveFilteredData: [],
  selectedTimes: {
    "All Day": true,
    "Early Morning": false,
    Morning: false,
    Afternoon: false,
    Evening: false,
  },
  selectedSubOptions: {},
  helpfulFilter: "All",
  wellnessPopupOpen: false,
};

export const useAnonymousData = (user, isAnonymous) => {
  const [localState, setLocalState] = useState(initialState);
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  useEffect(() => {
    if (isAnonymous) {
      const loadAnonymousData = async () => {
        setIsLocalLoading(true);
        try {
          const data = await fetchData(localState, user, isAnonymous);

          // For now, just update with the data as-is to see if that fixes infinite loading
          setLocalState((prev) => ({ ...prev, ...data }));
        } catch (error) {
          logger.error("Error fetching anonymous data:", error);
        }
        setIsLocalLoading(false);
      };
      loadAnonymousData();
    }
  }, [isAnonymous, user]);

  // Trigger data processing when default selections are set after data loads
  useEffect(() => {
    if (
      !localState.loading &&
      localState.districts &&
      Object.keys(localState.districts).length > 0 &&
      localState.allStudents &&
      localState.allStudents.length > 0
    ) {
      // Apply the role's default scope once, the same way the dashboards do.
      if (!localState.selectedGroupType) {
        const processedData = applyDefaultSelection(localState, user);
        if (processedData) {
          setLocalState((prev) => ({ ...prev, ...processedData }));
        }
      }
    }
  }, [
    localState.loading,
    localState.districts,
    localState.allStudents,
    localState.chosenDistrict,
    localState.chosenSchool,
    localState.chosenClass,
    localState.selectedGroupType,
    user?.role,
  ]);

  const updateState = (updates) =>
    setLocalState((prev) => ({ ...prev, ...updates }));

  return {
    state: localState,
    updateState,
    isUpdating: isLocalLoading,
  };
};
